var createChapterQuizFrame = function() {
    var str = '<div class="modal-dialog" role="document">' +
        '<div class="modal-content">' +
            '<div class="modal-header">' +
                '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                '<h4 class="modal-title" id="myModalLabel">Chapter Quiz</h4>' +
            '</div><!-- modal-header -->' +
            '<div class="modal-body">' +
            // '<div class="form-group">' +
            // '<label for="select-exam">Select Exam Type</label>' +
            // '<select class="form-control" id="select-exam">' +
            // '<option value="">Select One</option>' +
            // '<option value="Basic">Basic</option>' +
            // '<option value="Core">Core</option>' +
            // '<option value="Applied">Applied</option>' +
            // '</select></div><!-- form-group -->' +
                '<div class="form-group quiz-name-group">' +
                '<label for="quiz-name">Name</label>' +
                '<input type="text" name="name" id="quiz-name" class="form-control"/>' +
                '</div>' +
                '<div class="quiz-custom-settings">' +
                    '<div class="settings-table-wrapper table-responsive"></div>' +
                '</div>' +
            '</div>' +
            '<div class="modal-footer">' +
                '<div class="form-group"><button type="button" class="btn btn-default" id="create-quiz-button">Create and GO!</button></div>' +
            '</div>' +
        '</div><!-- modal-content -->' +
        '</div><!-- modal-dialog -->';
    return $.parseHTML(str);
}

module.exports = createChapterQuizFrame;


//////////////////
// WEBPACK FOOTER
// ./src/create_chapter_quiz_frame.js
// module id = 299
// module chunks = 0